import Modal from '../../shared/modal/modal'

import { errorFormResponsEvent, successFormResponsEvent } from './forms.analytics'

function closeUpdateModal(target) {
  // We close the modal
  Modal.close()

  // Colapsar las preferencias de usuario
  document.querySelectorAll('.questions .question').forEach(function (element) {
    element.classList.remove('current')
  })

  if (target) {
    $.fancybox.close()
  }
}

function loadErrorMessage(error) {
  const code = String(error.code)

  switch (code) {
    case '501':
      return 'user or password incorrect'
    case '4026':
      return 'existing agency'
    default:
      return error.message
  }
}

function backToForm(contactFlashMessageError) {
  const backErrorButton = contactFlashMessageError.querySelector('.js-back-to-form')
  backErrorButton.addEventListener('click', e => {
    window.location.reload()
  })
}

function setFlashMessageText(message, form, flashMessageContainer, stringValue) {
  const flashMessageText = flashMessageContainer.querySelector('.js-flash-message-text')
  if (flashMessageText) {
    const submitButton = form.querySelector('button[type=submit]')
    submitButton.disabled = false
    submitButton.textContent = ''
    submitButton.textContent = stringValue
    flashMessageText.innerHTML = message
  }
}

export function initSubmitFormRequest() {
  document.addEventListener('submit', function (event) {
    const form = event.target.closest('.js-utag-form-request')
    if (!form) {
      return
    }
    event.preventDefault()

    const submitButton = form.querySelector('button[type=submit]')
    const stringValue = submitButton ? submitButton.textContent : 'Submit'
    const target = event.target.querySelector('.js-submit-handler-modal')
    const flashMessageContainer = target
      ? window.parent.document.querySelector('.js-flash-message-container')
      : form.querySelector('.js-flash-message-container')

    const flashMessageAlert = flashMessageContainer?.querySelector('.js-flash-alert-message')
    const formName = form.dataset.formName

    const actionUrl = event.target.action
    const formData = new FormData(form)

    // Obtener el valor del campo _method si existe
    const methodField = form.querySelector('input[name="_method"]')
    let method = methodField ? methodField.value : form.method

    if (method.toLowerCase() === 'patch') {
      method = 'put'
    }
    const currentForm = form

    fetch(actionUrl, {
      method: method.toUpperCase(),
      body: formData,
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
      },
    })
      .then(response => {
        return response.json()
      })
      .then(data => {
        flashMessageContainer?.classList.remove('hidden')
        if (data.status === 200 || data.status === 'ok') {
          if (data.redirect_url) {
            flashMessageContainer.classList.add('hidden')
            window.location.href = data.redirect_url
          } else {
            if (formName === 'contact form' || formName === 'rfp') {
              const flashMessageSuccess = document.querySelector('.js-flash-message-success')
              form.classList.add('hidden')
              flashMessageSuccess.classList.remove('hidden')
            } else {
              flashMessageAlert.classList.remove('alert-danger')

              flashMessageAlert.classList.add('alert-success')

              setFlashMessageText(data.message, form, flashMessageContainer, stringValue)
            }

            if (target) {
              parent.$.fancybox.close()
            }

            // We need to check if the form has a modal to close
            if (data.hasModalToClose === true) {
              closeUpdateModal()
            }
          }
          $.fancybox.close(document.querySelector('#loading-register'))
          successFormResponsEvent(currentForm)
        } else if (data.status === 500) {
          if (formName === 'contact form') {
            const contactFlashMessageError = document.querySelector('.js-flash-message-error')
            form.classList.add('hidden')
            contactFlashMessageError.classList.remove('hidden')
            backToForm(contactFlashMessageError)
          } else {
            flashMessageAlert.classList.remove('alert-success')
            flashMessageAlert.classList.add('alert-danger')
            setFlashMessageText(data.error, form, flashMessageContainer, stringValue)

            if (target) {
              parent.$.fancybox.close()
            }
          }
          errorFormResponsEvent(currentForm, data.message)
          $.fancybox.close(document.querySelector('#loading-register'))
        }
      })
      .catch(error => {
        if (formName === 'contact form') {
          const contactFlashMessageError = document.querySelector('.js-flash-message-error')
          form.classList.add('hidden')
          contactFlashMessageError.classList.remove('hidden')
          backToForm(contactFlashMessageError)
        } else {
          flashMessageContainer.classList.remove('hidden')
          flashMessageAlert.classList.remove('alert-success')
          flashMessageAlert.classList.add('alert-danger')
          setFlashMessageText(error.error, form, flashMessageContainer, stringValue)

          const flashMessageText = flashMessageAlert.querySelector('.js-flash-message-text')
          flashMessageText.innerHTML = error.error

          if (target) {
            parent.$.fancybox.close()
          }

          // We need to check if the form has a modal to close
          if (error.hasModalToClose === true) {
            closeUpdateModal()
          }
        }
        const errorMsg = loadErrorMessage(error)
        errorFormResponsEvent(currentForm, errorMsg)
        $.fancybox.close(document.querySelector('#loading-register'))
      })
  })
}
if (typeof IB === 'undefined') {
  window.IB = {}
}

if (IB.initFormRequest === undefined) {
  window.IB.initFormRequest = {
    init: initSubmitFormRequest,
  }
}
